export const V2_ROUTE_AREAS = {
  home: '/',
  analysis: '/analysis',
  assessments: '/assessments',
  itemBank: '/item-bank',
  students: '/students'
};

export const V2_ROUTE_PAGES = {
  administerAssessments: `${V2_ROUTE_AREAS.assessments}/administer`,
  analysisAxiom: `${V2_ROUTE_AREAS.analysis}/axiom`,
  analysisAxiom3: `${V2_ROUTE_AREAS.analysis}/axiom3`,
  analysisDataViewsBank: `${V2_ROUTE_AREAS.analysis}/data-views-bank`,
  analysisMultiTest: `${V2_ROUTE_AREAS.analysis}/multi`,
  analysisQuickViews: `${V2_ROUTE_AREAS.analysis}/quick-views`,
  analysisReports: `${V2_ROUTE_AREAS.analysis}/reports`,
  analysisSettings: `${V2_ROUTE_AREAS.analysis}/settings`,
  analysisSingleTest: `${V2_ROUTE_AREAS.analysis}/single`,
  assessmentsSettings: `${V2_ROUTE_AREAS.assessments}/settings`,
  authorAssessments: `${V2_ROUTE_AREAS.assessments}/author`,
  enterAnswers: `${V2_ROUTE_AREAS.assessments}/administer/answers`,
  help: `${V2_ROUTE_AREAS.home}help`,
  itemBankQuestionsAndResources: `${V2_ROUTE_AREAS.itemBank}/questions-and-resources`,
  itemBankReports: `${V2_ROUTE_AREAS.itemBank}/reports`,
  itemBankSettings: `${V2_ROUTE_AREAS.itemBank}/settings`,
  itemBankPrebuiltTests: `${V2_ROUTE_AREAS.itemBank}/tests`,
  customItemBank: `${V2_ROUTE_AREAS.itemBank}/custom`,
  overview: `${V2_ROUTE_AREAS.home}overview`,
  proctorAssessments: `${V2_ROUTE_AREAS.assessments}/proctor`,
  studentForms: `${V2_ROUTE_AREAS.students}/forms`,
  studentMastery: `${V2_ROUTE_AREAS.students}/mastery`,
  studentMonitorGroups: `${V2_ROUTE_AREAS.students}/monitor-groups`,
  studentPortfolios: `${V2_ROUTE_AREAS.students}/portfolios`,
  studentProfiles: `${V2_ROUTE_AREAS.students}/profiles`,
  studentReports: `${V2_ROUTE_AREAS.students}/reports`,
  studentSettings: `${V2_ROUTE_AREAS.students}/settings`
};
